import { render, staticRenderFns } from "./IconAdd.vue?vue&type=template&id=e1689b98"
import script from "./IconAdd.vue?vue&type=script&lang=js"
export * from "./IconAdd.vue?vue&type=script&lang=js"
import style0 from "./IconAdd.vue?vue&type=style&index=0&id=e1689b98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports